import { create } from 'zustand';
import type { inquiryStore } from './storeTypes';

export const useInquiryStore = create<inquiryStore>((set) => ({
  isComplete: false,
  phone: '',
  setComplete: (phone) => set({ isComplete: true, phone: phone }),
}));
